/**
 * Created by Gaplo917 on 9/7/2017.
 */
import * as PIXI from "pixi.js";
import R from "../config/R"
import Scene from "../objects/Scene"
import Image from "../objects/Image"
import FullScreenOverlay from "../objects/FullScreenOverlay";

export default class InfoScene extends Scene {
  constructor(resources, texture){
    super()

    const tutorialBg = new FullScreenOverlay(0xffffff, 0.4)
    const msg = new Image(0, 0, texture)

    // switch(level){
    //   case 1 :
    //     if (status === 'success')
    //       this.msg = new Image(0, 0, resources[R.images.success_01.name].texture)
    //     else
    //       this.msg = new Image(0, 0, resources[R.images.fail_01.name].texture)
    //     break
    //   case 2 :
    //     if (status === 'success')
    //       this.msg = new Image(0, 0, resources[R.images.success_02.name].texture)
    //     else
    //       this.msg = new Image(0, 0, resources[R.images.fail_02.name].texture)
    //     break
    //   case 3 :
    //     if (status === 'success')
    //       this.msg = new Image(0, 0, resources[R.images.success_03.name].texture)
    //     else
    //       this.msg = new Image(0, 0, resources[R.images.fail_03.name].texture)
    //     break
    // }

    msg.x = tutorialBg.width / 2
    msg.y = tutorialBg.height / 2

    this.displayGroup = new PIXI.DisplayGroup(10, true)
    this.interactive = false
    this.buttonMode = false

    this.addChild(tutorialBg)
    this.addChild(msg)
  }
}



// WEBPACK FOOTER //
// ./src/game/scenes/InfoScene.js